import React from "react";
import Dropdown from "@radarly/components/panels/card-edition/sidebar/dropdown";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { useMainUnit } from "./model";

export interface MainUnitProps {
  dataviz: DatavizHorizontalBarChart;
  setDataviz: (dataviz: DatavizHorizontalBarChart) => void;
}

export default function MainUnit({ dataviz, setDataviz }: MainUnitProps) {
  const {
    label,
    options: mainUnitOptions,
    option: mainUnitOption,
    onChange: onChangeMainUnit,
  } = useMainUnit(dataviz, setDataviz);
  return (
    <Dropdown
      label={label}
      value={mainUnitOption}
      options={mainUnitOptions}
      onChange={onChangeMainUnit}
    />
  );
}
